import { IntegrationsContract } from '@terra/shared-contracts-integrations';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const integrationsClient = createTerraOrpcClient({
  contract: IntegrationsContract,
  serviceName: SERVICE_NAME,
});
